// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  margin-top: 8rem;
  min-height: calc(100vh - 8rem);
  display: grid;
  place-items: center;
  background: var(--color-white);
  transition: var(--transition);
  padding: 2rem 0;
}

.header__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.header__profile {
  width: 18rem;
  height: 22rem;
  border-radius: 9rem 9rem 2rem 2rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.header__container p {
  width: 35rem;
  text-align: center;
  margin: 0.6rem 0 2rem;
}

.header__cta {
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.header__socials {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 10;
}

.header__socials a {
  width: 2.5rem;
  aspect-ratio: 1/1;
  background: var(--color-light);
  color: var(--color-black);
  display: grid;
  place-items: center;
  border-radius: var(--border-radius-3);
  text-decoration: none;
  transition: var(--transition);
  cursor: pointer;
}

.header__socials a:hover {
  background: var(--color-primary);
  color: var(--color-white);
  transform: translateX(-0.5rem);
}

/* Media queries tablets */

@media screen and (max-width: 1024px) {
  header {
    margin-top: 6rem;
    min-height: calc(100vh - 6rem);
  }
}

/* Media queries phones */

@media screen and (max-width: 600px) {
  header {
    margin-top: 7rem;
    min-height: calc(100vh - 7rem);
  }

  .header__profile {
    width: 14rem;
    height: 17rem;
    max-width: 60%;
    max-height: 35vh;
  }

  .header__container p {
    width: 100%;
  }

  .header__cta {
    gap: 1rem;
  }

  .header__socials {
    display: flex;
    position: static;
    transform: none;
    flex-direction: row;
    justify-content: center;
    margin-top: 1rem;
    z-index: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/header/header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,0BAA0B;;AAE1B;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;AACF;;AAEA,yBAAyB;;AAEzB;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;EACZ;AACF","sourcesContent":["header {\n  margin-top: 8rem;\n  min-height: calc(100vh - 8rem);\n  display: grid;\n  place-items: center;\n  background: var(--color-white);\n  transition: var(--transition);\n  padding: 2rem 0;\n}\n\n.header__container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.header__profile {\n  width: 18rem;\n  height: 22rem;\n  border-radius: 9rem 9rem 2rem 2rem;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n\n.header__container p {\n  width: 35rem;\n  text-align: center;\n  margin: 0.6rem 0 2rem;\n}\n\n.header__cta {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n}\n\n.header__socials {\n  position: fixed;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  z-index: 10;\n}\n\n.header__socials a {\n  width: 2.5rem;\n  aspect-ratio: 1/1;\n  background: var(--color-light);\n  color: var(--color-black);\n  display: grid;\n  place-items: center;\n  border-radius: var(--border-radius-3);\n  text-decoration: none;\n  transition: var(--transition);\n  cursor: pointer;\n}\n\n.header__socials a:hover {\n  background: var(--color-primary);\n  color: var(--color-white);\n  transform: translateX(-0.5rem);\n}\n\n/* Media queries tablets */\n\n@media screen and (max-width: 1024px) {\n  header {\n    margin-top: 6rem;\n    min-height: calc(100vh - 6rem);\n  }\n}\n\n/* Media queries phones */\n\n@media screen and (max-width: 600px) {\n  header {\n    margin-top: 7rem;\n    min-height: calc(100vh - 7rem);\n  }\n\n  .header__profile {\n    width: 14rem;\n    height: 17rem;\n    max-width: 60%;\n    max-height: 35vh;\n  }\n\n  .header__container p {\n    width: 100%;\n  }\n\n  .header__cta {\n    gap: 1rem;\n  }\n\n  .header__socials {\n    display: flex;\n    position: static;\n    transform: none;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 1rem;\n    z-index: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
